import { PermissionsScope } from '../../policies/policy.model'
import { SelectionData } from '../../../models/util.model'
import { ReplenishmentPriority } from '../models/replenishment.types'

export const REPLENISHMENT_FRAGMENT = 'replenishment'
export const REPLENISHMENT_SCOPE: PermissionsScope = 'replenishments'
export const REPLENISHMENT_PRIORITIES: SelectionData<ReplenishmentPriority>[] =
  [
    {
      label: 'High',
      value: 70,
    },
    {
      label: 'Medium',
      value: 40,
    },
    {
      label: 'Low',
      value: 20,
    },
  ]
